import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { AppForm } from "@/shared/Components";
import type { FC } from "react";
import type { ModalProps } from "antd/lib";
import { ModalWrapper } from "../ModalWrapper";
import { connectionSchema, type ConnectionFormValues } from "./schema";
import { ModalContent } from "./ModalContent";
import styles from "./styles.module.scss";

type Props = {
  onSubmit: (data: ConnectionFormValues) => void;
  defaultValues?: ConnectionFormValues;
} & ModalProps;

export const ModalConnectionAddition: FC<Props> = ({
  onSubmit,
  defaultValues = { additionalInfo: "", connection: "", personId: "", id: "" },
  ...props
}) => {
  const { t } = useTranslation();

  const formApi = useForm({
    resolver: yupResolver(connectionSchema),
    values: defaultValues,
  });

  const submitHandler = (data: ConnectionFormValues) => {
    onSubmit(data);
    formApi.reset();
  };

  return (
    <ModalWrapper
      type="save"
      modalTitle={t("contactsPage.connection")}
      okButtonProps={{ htmlType: "submit" }}
      modalRender={(node) => (
        <AppForm onSubmit={submitHandler} className={styles["modal-form"]} formApi={formApi}>
          {node}
        </AppForm>
      )}
      {...props}
    >
      <ModalContent />
    </ModalWrapper>
  );
};
